import { useState, useEffect } from 'react';

import {
  trackingNotificationType,
  notificationStatusType,
  notificationTabs,
} from '../constants';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import * as api from '../utils/api';
import * as URLS from '../constants/urls';
import { updateTotalUnread } from '../components/Notification/NotificationSlice';

const LIMIT = 40;

let isFollowCompanyRunning = false;
let isGetUnreadRunning = false;

const useNotification = () => {
  const dispatch = useAppDispatch();
  const { open: openNotificationDrawer, activeTab } = useAppSelector(
    (state) => state.notification
  );
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [totalUnread, setTotalUnread] = useState(0);
  const [isShowLogoutModal, setShowLogoutModal] = useState(false);
  const [activePackage, setActivePackage] = useState(null);
  const [keyword, setKeyword] = useState('');
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [selectedType, setSelectedType] = useState('');
  const [isUnreadSelected, setUnreadSelected] = useState(false);

  const [investmentNotifications, setInvestmentNotifications] = useState({});
  const [followNotifications, setFollowNotifications] = useState({});
  const [otherNotifications, setOtherNotifications] = useState({});
  const [
    isInvestmentNotificationsLoading,
    setInvestmentNotificationsLoading,
  ] = useState(true);
  const [isFollowLoading, setFollowLoading] = useState(true);
  const [isOtherLoading, setOtherLoading] = useState(true);

  const [isInvestmentLoading, setInvestmentLoading] = useState(false);
  const [isUnreadNotificationLoading, setUnreadNotificationLoading] = useState(
    false
  );
  const [investmentStocks, setInvestmentStocks] = useState([]);
  const [isFollowCompanyLoading, setFollowCompanyLoading] = useState(false);
  const [followStocks, setFollowStocks] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState([]);
  const [selectedFollowCategory, setSelectedFollowCategory] = useState(null);
  const [selectedFollowStock, setSelectedFollowStock] = useState('');
  const [selectedInvestmentStock, setSelectedInvestmentStock] = useState('');
  const [
    investmentUnreadNotifications,
    setInvestmentUnreadNotifications,
  ] = useState([]);
  const [followUnreadNotifications, setFollowUnreadNotifications] = useState(
    []
  );
  const [otherUnreadNotifications, setOtherUnreadNotifications] = useState([]);
  const [notificationId, setNotificationId] = useState('');

  const handleSelectedStock = (stock, tab = currentTab, catId = '') => {
    switch (tab) {
      case notificationTabs.Investment:
        setSelectedInvestmentStock(stock);
        if (!investmentNotifications[stock]) {
          fetchInvestmentNotification(stock);
        }
        break;
      case notificationTabs.Follow:
        setSelectedFollowStock(stock);
        if (!followNotifications[stock]) {
          fetchFollowNotification(stock);
        }
        break;
      case notificationTabs.Other:
        fetchOtherNotification();
        break;
    }
  };

  const handleTypeChange = (type) => {
    setAnchorElFilter(null);
    let currentType = type;
    let selectedStatus = [];
    if (type === 'unread') {
      selectedStatus = [
        notificationStatusType.New,
        notificationStatusType.View,
      ];
      currentType = selectedType;
      setUnreadSelected(true);
    } else {
      setSelectedType(type);
      setUnreadSelected(false);
    }
    switch (currentTab) {
      case notificationTabs.Investment:
        fetchInvestmentNotification(
          selectedInvestmentStock,
          1,
          currentType,
          '',
          selectedStatus
        );
        break;
      case notificationTabs.Follow:
        fetchFollowNotification(
          selectedFollowStock,
          1,
          currentType,
          '',
          selectedStatus
        );
        break;
      case notificationTabs.Other:
        fetchOtherNotification(1, currentType, '', selectedStatus);
        break;
    }
  };

  const handleKeywordChange = (keyword) => {
    setKeyword(keyword);
    switch (currentTab) {
      case notificationTabs.Investment:
        fetchInvestmentNotification(selectedInvestmentStock, 1, '', keyword);
        break;
      case notificationTabs.Follow:
        fetchFollowNotification(selectedFollowStock, 1, '', keyword);
        break;
      case notificationTabs.Other:
        fetchOtherNotification(1, '', keyword);
        break;
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue !== 1) {
      setCurrentTab(newValue);
    }
  };

  const handleOpenFilterMenu = (event) => {
    setAnchorElFilter(event.currentTarget);
  };

  const handleCloseFilterMenu = () => {
    setAnchorElFilter(null);
  };

  const formatDataUnread = (dataUnread) => {
    const results = [];
    for (const item of dataUnread) {
      const tags = item.tags ? JSON.parse(item.tags) : [];
      for (const tag of tags) {
        const exist = results.find((r) => r.stock === tag);
        if (exist) {
          const index = results.findIndex((r) => r.stock === tag);
          results[index] = {
            ...exist,
            total: exist.total + 1,
          };
        } else {
          results.push({
            stock: tag,
            total: 1,
            countCategoryNU: 1,
          });
        }
      }
    }
    return results;
  };

  const getTotalUnreadOrSentNotifications = async () => {
    try {
      const { data } = await api.get(
        URLS.GET_TOTAL_UNREAD_OR_SENT_NOTIFICATIONS_URL
      );
      const { data: allFollowCompany } = await api.get(
        URLS.GET_ALL_FOLLOW_COMPANY_URL
      );
      const transferDataFollowCompany = allFollowCompany.reduce((acc, item) => {
        const existingItem = acc.find(
          (resultItem) => resultItem.machungkhoan === item.machungkhoan
        );
        if (existingItem) {
          if (!existingItem.categories.includes(item.category_id)) {
            existingItem.categories.push(item.category_id);
          }
        } else {
          acc.push({
            id: item.id,
            machungkhoan: item.machungkhoan,
            categories: [item.category_id],
          });
        }
        return acc;
      }, []);

      const total = data.totalUnRead;
      setInvestmentUnreadNotifications(formatDataUnread(data.itemInvestment));
      const dataFollowUnread = formatDataUnread(data.itemFollow);
      data.itemFollow.forEach((item) => {
        let existingFollowCompany = transferDataFollowCompany.find(
          (e) => e.machungkhoan === item.stock
        );
        let existingFollowUnread = dataFollowUnread.find(
          (e) => e.stock === item.stock
        );
        if (existingFollowUnread) {
          existingFollowUnread.countCategoryNU =
            existingFollowUnread.countCategoryNU *
            existingFollowCompany?.categories?.length;
        }
      });
      setFollowUnreadNotifications(dataFollowUnread);
      setOtherUnreadNotifications(data.itemSystem);

      dispatch(updateTotalUnread(total));
    } catch (error) {
      console.error(error);
    }
  };

  const updateViewStatusNotification = async () => {
    if (!notificationId) {
      return;
    }
    try {
      await api.post(URLS.UPDATE_VIEW_STATUS_NOTIFICATION_BY_ID, {
        id: notificationId,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getUnViewIds = (items) => {
    return items
      .filter((i) => i.status == notificationStatusType.Sent)
      .map((i) => i.id);
  };

  const updateViewStatusForNotificationByIds = async (items) => {
    if (getUnViewIds(items).length == 0) {
      return;
    }
    try {
      await api.post(URLS.UPDATE_VIEW_STATUS_FOR_NOTIFICATION_BY_IDS_URL, {
        ids: getUnViewIds(items),
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchInvestmentNotification = async (
    selectedInvestmentStock = '',
    currentInvestmentPage = 1,
    selectedType = '',
    keyword = '',
    selectedStatus = []
  ) => {
    setInvestmentNotificationsLoading(true);
    try {
      if (
        selectedType &&
        [
          trackingNotificationType.companyExercise,
          trackingNotificationType.priceChange,
          trackingNotificationType.newsUpdate,
          trackingNotificationType.Synthetic,
          trackingNotificationType.Investment,
          trackingNotificationType.GENERAL,
          trackingNotificationType.Notification,
          trackingNotificationType.Warning,
        ].indexOf(selectedType) === -1
      ) {
        setInvestmentNotifications({
          ...investmentNotifications,
          [selectedInvestmentStock]: {},
        });
      } else {
        let type = selectedType
          ? [selectedType]
          : [
              trackingNotificationType.companyExercise,
              trackingNotificationType.priceChange,
              trackingNotificationType.newsUpdate,
              trackingNotificationType.Synthetic,
              trackingNotificationType.Investment,
              trackingNotificationType.GENERAL,
              trackingNotificationType.Notification,
              trackingNotificationType.Warning,
            ];
        const { data } = await api.post(URLS.GET_INVESTMENT_NOTIFICATION_URL, {
          type: type,
          offset: LIMIT * (currentInvestmentPage - 1),
          limit: LIMIT,
          keyword,
          stock: selectedInvestmentStock,
          status: selectedStatus,
        });
        updateViewStatusForNotificationByIds(data.results);
        setInvestmentNotifications({
          ...investmentNotifications,
          [selectedInvestmentStock]: {
            data: data.results,
            currentPage: currentInvestmentPage,
            totalPage: Math.ceil(data.total / LIMIT),
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
    setInvestmentNotificationsLoading(false);
  };

  const getFollowInformation = (items = [], selectedFollowStock = '') => {
    const results = [];
    for (const item of items) {
      if (item.type !== trackingNotificationType.GENERAL_FOLLOW) {
        results.push(item);
      } else {
        const otherInfo = JSON.parse(item.otherInfo);
        if (otherInfo) {
          results.push(item);
        }
      }
    }

    return results;
  };

  const fetchFollowNotification = async (
    selectedFollowStock = '',
    currentFollowPage = 1,
    selectedType = '',
    keyword = '',
    selectedStatus = []
  ) => {
    setFollowLoading(true);
    try {
      if (
        selectedType &&
        [
          trackingNotificationType.volumeChange,
          trackingNotificationType.Indicator,
          trackingNotificationType.GENERAL_FOLLOW,
          trackingNotificationType.Notification,
          trackingNotificationType.Warning,
        ].indexOf(selectedType) === -1
      ) {
        setFollowNotifications({
          ...followNotifications,
          [selectedFollowStock]: {},
        });
      } else {
        const { data } = await api.post(
          URLS.GET_FOLLOW_COMPANY_NOTIFICATION_URL,
          {
            type: [
              trackingNotificationType.volumeChange,
              trackingNotificationType.newsUpdate,
              trackingNotificationType.Indicator,
              trackingNotificationType.GENERAL_FOLLOW,
              trackingNotificationType.Notification,
              trackingNotificationType.Warning,
            ],
            offset: LIMIT * (currentFollowPage - 1),
            limit: LIMIT,
            keyword: keyword,
            stock: selectedFollowStock,
            status: selectedStatus,
          }
        );
        updateViewStatusForNotificationByIds(data.results);
        setFollowNotifications({
          ...followNotifications,
          [selectedFollowStock]: {
            data: getFollowInformation(data.results, selectedFollowStock),
            currentPage: currentFollowPage,
            totalPage: Math.ceil(data.total / LIMIT),
          },
        });
        if (
          activeTab == 1 ||
          window.location.href.includes('danh-muc-theo-doi')
        ) {
          setCurrentTab(1);
        }
      }
    } catch (error) {
      console.error(error);
    }
    setFollowLoading(false);
  };

  const fetchOtherNotification = async (
    currentOtherPage = 1,
    selectedType = '',
    keyword = '',
    selectedStatus
  ) => {
    setOtherLoading(true);
    try {
      if (
        selectedType &&
        [
          trackingNotificationType.system,
          trackingNotificationType.PackagePayment,
          trackingNotificationType.PackageNotPayment,
        ].indexOf(selectedType) === -1
      ) {
        setOtherNotifications({});
      } else {
        const { data } = await api.post(URLS.GET_SYSTEM_NOTIFICATION_URL, {
          type: selectedType
            ? [selectedType]
            : [
                trackingNotificationType.system,
                trackingNotificationType.PackagePayment,
                trackingNotificationType.PackageNotPayment,
              ],
          offset: LIMIT * (currentOtherPage - 1),
          limit: LIMIT,
          keyword,
          status: selectedStatus,
        });
        updateViewStatusForNotificationByIds(data.results);
        setOtherNotifications({
          data: data.results,
          currentPage: currentOtherPage,
          totalPage: Math.ceil(data.total / LIMIT),
        });
      }
    } catch (error) {
      console.error(error);
    }
    setOtherLoading(false);
  };

  const fetchFollowCompanyStocks = async () => {
    setFollowCompanyLoading(true);
    try {
      const { data: investmentCategory } = await api.get(
        URLS.GET_INVESTMENT_CATEGORY_URL
      );
      const { data } = await api.get(URLS.GET_ALL_FOLLOW_COMPANY_URL);
      const results = [];
      investmentCategory?.forEach((inv) => {
        if (Number(inv.total) > 0) {
          const items = data.filter((d) => d.category_id === inv.id);
          results.push({
            id: inv.id,
            name: inv.name,
            isDefault: inv.isDefault,
            total: inv.total,
            items: [
              { id: Date.now(), machungkhoan: 'general', category_id: inv.id },
              ...items,
            ],
          });
        }
      });
      setFollowStocks(results);
      const defaultStock = results.find((e) => e.isDefault) || results[0];
      if (
        activeTab == 1 ||
        window.location.href.includes('danh-muc-theo-doi')
      ) {
        setSelectedFollowCategory([defaultStock]);
        if (defaultStock?.items?.length) {
          setSelectedFollowStock(defaultStock.items[0].machungkhoan);
          fetchFollowNotification(defaultStock.items[0].machungkhoan);
        } else {
          setSelectedFollowStock('');
          fetchFollowNotification('');
        }
      } else {
        setSelectedFollowStock(results[0]?.items?.[0]?.machungkhoan);
        fetchFollowNotification(results[0]?.items?.[0]?.machungkhoan);
      }
    } catch (error) {
      console.error(error);
    }
    setFollowCompanyLoading(false);
  };

  const fetchInvestmentStocks = async () => {
    setInvestmentLoading(true);
    try {
      const { data } = await api.get(
        URLS.GET_INVESTMENT_STOCKS_FOR_NOTIFICATION_URL
      );
      setInvestmentStocks([{ machungkhoan: 'general' }, ...data]);
      setSelectedInvestmentStock('general');
      fetchInvestmentNotification('general');
      if (
        activeTab == 1 ||
        window.location.href.includes('danh-muc-theo-doi')
      ) {
        setCurrentTab(1);
      }
    } catch (error) {
      console.error(error);
    }
    setInvestmentLoading(false);
  };

  const handleFetchData = async () => {
    if (isFollowCompanyRunning) {
      return;
    }
    isFollowCompanyRunning = true;
    try {
      await fetchInvestmentStocks();
      await fetchFollowCompanyStocks();
      await fetchOtherNotification();
    } catch (error) {
      console.error(error);
    }
    isFollowCompanyRunning = false;
  };

  const handleGetTotalUnreadNotification = async () => {
    if (isGetUnreadRunning) {
      return;
    }
    isGetUnreadRunning = true;
    try {
      await getTotalUnreadOrSentNotifications();
    } catch (error) {
      console.error(error);
    }
    isGetUnreadRunning = false;
  };

  useEffect(() => {
    handleGetTotalUnreadNotification();
  }, []);

  useEffect(() => {
    if (
      !isInvestmentNotificationsLoading &&
      !isFollowLoading &&
      !isOtherLoading
    ) {
      setIsPageLoading(false);
    }
  }, [isInvestmentNotificationsLoading, isFollowLoading, isOtherLoading]);

  useEffect(() => {
    if (openNotificationDrawer) {
      setIsPageLoading(true);
      setInvestmentNotificationsLoading(true);
      setFollowLoading(true);
      setOtherLoading(true);
      handleFetchData();
    }
  }, [openNotificationDrawer]);

  const [dataSnackBar, setDataSnackBar] = useState({
    message: '',
    isError: false,
    show: false,
  });

  const checkAndGetNotificationRelated = (
    listIdNotification,
    notifications,
    status
  ) => {
    //only run with tab = invest or follow
    let selectedStock =
      currentTab === notificationTabs.Investment
        ? selectedInvestmentStock
        : selectedFollowStock;
    let oldNotifications = { ...notifications };
    let existing = false;
    listIdNotification.forEach((id) => {
      if (notifications[selectedStock]) {
        let findIndex = notifications[selectedStock].data.findIndex(
          (e) => e.id === id
        );
        if (findIndex !== -1) {
          oldNotifications[selectedStock].data[findIndex].status = status;
          existing = true;
        }
      }
    });

    return existing ? oldNotifications : null;
  };

  const updateStatusNotificationsWhenChange = (listIdNotification, status) => {
    if (currentTab == notificationTabs.Other) {
      setOtherNotifications(
        updateStatusNoficationsOfStock(
          otherNotifications,
          '',
          listIdNotification,
          status
        )
      );
    } else {
      let checkInvestmentNotifications = checkAndGetNotificationRelated(
        listIdNotification,
        investmentNotifications,
        status
      );
      let checkFollowNotifications = checkAndGetNotificationRelated(
        listIdNotification,
        followNotifications,
        status
      );
      if (checkInvestmentNotifications) {
        setInvestmentNotifications(checkInvestmentNotifications);
      }

      if (checkFollowNotifications) {
        setFollowNotifications(checkFollowNotifications);
      }
    }
  };

  const handleUpdateReadNotification = async (ids) => {
    try {
      const { data } = await api.put(URLS.MASK_AS_READ_NOTIFICATION_URL, {
        ids,
      });
      if (data.status) {
        await getTotalUnreadOrSentNotifications();
        updateStatusNotificationsWhenChange(ids, notificationStatusType.Read);
        setDataSnackBar({
          message: 'Thay đổi trạng thái thông báo thành công',
          isError: false,
          show: true,
        });
      }
    } catch (error) {
      console.error(error);
      setDataSnackBar({
        message: 'Thay đổi trạng thái thông báo thất bại',
        isError: true,
        show: true,
      });
    }
  };

  const handlePageChange = (value) => {
    switch (currentTab) {
      case notificationTabs.Investment:
        fetchInvestmentNotification(selectedInvestmentStock, Number(value));
        break;
      case notificationTabs.Follow:
        fetchFollowNotification(selectedFollowStock, Number(value));
        break;
      case notificationTabs.Other:
        fetchOtherNotification(Number(value));
        break;
    }
  };

  const updateStatusNoficationsOfStock = (
    notifications,
    selectedStock,
    ids,
    status
  ) => {
    return !selectedStock
      ? {
          ...notifications,
          data: notifications.data.map((e) => {
            return ids.includes(e.id)
              ? {
                  ...e,
                  status: status,
                }
              : e;
          }),
        }
      : {
          ...notifications,
          [selectedStock]: {
            ...notifications[selectedStock],
            data: notifications[selectedStock].data.map((e) => {
              return ids.includes(e.id)
                ? {
                    ...e,
                    status: status,
                  }
                : e;
            }),
          },
        };
  };

  const handleToggleRead = async (checked, id, type) => {
    try {
      const status = checked
        ? notificationStatusType.View
        : notificationStatusType.Read;
      const { data } = await api.put(`/notification/${id}/status`, {
        status,
      });
      if (data?.id) {
        await getTotalUnreadOrSentNotifications();
        updateStatusNotificationsWhenChange([id], data.status);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFollowCategoryChange = (item) => {
    setSelectedFollowCategory(item);
  };

  let _followNotifications = followNotifications;
  if (
    selectedFollowStock === 'general' &&
    followNotifications['general']?.data?.length &&
    selectedFollowCategory?.id
  ) {
    const newFollowNotifications = followNotifications['general'].data.filter(
      (f) =>
        (f.tags.indexOf('follow') !== -1 &&
          f.tags.indexOf(`category-${selectedFollowCategory.id}`) !== -1) ||
        f.type === trackingNotificationType.Indicator ||
        (f.tags.indexOf('stock_potential') !== -1 &&
          f.tags.indexOf('follow') !== -1)
    );
    _followNotifications = {
      ...followNotifications,
      general: {
        ..._followNotifications['general'],
        data: newFollowNotifications,
      },
    };
  }

  return {
    totalUnread,
    handleUpdateReadNotification,
    investmentNotifications,
    handlePageChange,
    isInvestmentNotificationsLoading,
    followNotifications: _followNotifications,
    isFollowLoading,
    otherNotifications,
    isOtherLoading,
    handleTabChange,
    handleOpenFilterMenu,
    handleCloseFilterMenu,
    anchorElFilter,
    currentTab,
    keyword,
    handleKeywordChange,
    handleTypeChange,
    selectedType,
    handleToggleRead,
    investmentStocks,
    isInvestmentLoading,
    isFollowCompanyLoading,
    followStocks,
    isUnreadNotificationLoading,
    unreadNotifications,
    investmentUnreadNotifications,
    followUnreadNotifications,
    selectedFollowCategory,
    setSelectedFollowCategory,
    handleFollowCategoryChange,
    selectedFollowStock,
    setSelectedFollowStock,
    selectedInvestmentStock,
    setSelectedInvestmentStock,
    isShowLogoutModal,
    activePackage,
    updateViewStatusNotification,
    dataSnackBar,
    handleSelectedStock,
    isUnreadSelected,
    setCurrentTab,
    otherUnreadNotifications,
    isPageLoading,
  };
};
export default useNotification;
